module.exports = __webpack_public_path__ + "static/img/cash-bg.2bfaa364.png";